/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cloud_logic_custom": [
        {
            "name": "externalRestApi",
            "endpoint": "https://wg79f4jrfg.execute-api.us-east-2.amazonaws.com/beta",
            "region": "us-east-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://d4orl36qpne3tbscydsf4v7t4a.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AWS_LAMBDA",
    "aws_appsync_apiKey": "da2-vsqm4tofkvb2zbqmt64bu265qa",
    "aws_cognito_identity_pool_id": "us-east-2:43a2536c-fb87-4351-8a06-a24ed1a97ed2",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_AwZonjEwt",
    "aws_user_pools_web_client_id": "6hra3m5v20alj3p9jan88lktcu",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "s3-cloudfront-hosting141349-beta",
    "aws_content_delivery_bucket_region": "us-east-2",
    "aws_content_delivery_url": "https://d2cdv2s31fv11c.cloudfront.net",
    "aws_user_files_s3_bucket": "attachments141349-beta",
    "aws_user_files_s3_bucket_region": "us-east-2",
    "aws_cloudwatch_rum_app_id": "39f806ca-e07e-4b6d-83ca-56920e6e5906",
    "aws_cloudwatch_rum_client_ingress_app_id": "1abb0961-ebda-42ed-bbd3-e90f9e585f53"
};


export default awsmobile;
